import { SENDOSO_ORIGIN_SUFIX } from 'swag-client-common/libs/url-modifier.sendoso';
import { BundleType } from 'swag-common/constants/main-swag.constants';
export const replaceCDNToOrigin = url => {
  const parsedUrl = new URL(url);
  const pathname = String(parsedUrl.pathname).replace(`${BundleType.SENDOSO}/`, '');
  const sameOriginWorkerUrl = new URL(SENDOSO_ORIGIN_SUFIX ? `${SENDOSO_ORIGIN_SUFIX}${pathname}`.replace('//', '/') : `${pathname}`, globalThis.location.origin);
  return sameOriginWorkerUrl;
};